import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material';
import { SubregionAssignment } from '../loanofficerregionreference.model';
import { SubregionEditComponent } from '../subregion-edit/subregion-edit.component';
import { SubregionService } from './subregions.service';

@Component({
  selector: 'app-subregions',
  templateUrl: './subregions.component.html',
  styleUrls: ['./subregions.component.css']
})
export class SubregionsComponent implements OnInit {

    @Input() public subregionAssignment: SubregionAssignment;
    public subregionAssignmentName;
    constructor(private subregionService: SubregionService, public dialog: MatDialog) { }

    ngOnInit() {
        this.subregionAssignmentName = this.subregionAssignment.city
    }

    editSubregionAssignment(subregionAssignment) {
        let dialogRef = this.dialog.open(SubregionEditComponent, {
            data: this.subregionAssignment,
            height: "330px",
            width: "520px",
            panelClass: "property-type-screen" 
        });
        dialogRef.afterClosed().subscribe((result: SubregionAssignment) => {
            if (result)
            {
                this.subregionAssignmentName = result.city;
            }
        })
    }

    deleteSubregionAssignment(subregionAssignmnet: SubregionAssignment) {
        if (confirm('Are you sure you want to delete ' + subregionAssignmnet.city + '?')) {
            this.subregionService.deleteSubregionAssignments(subregionAssignmnet.id)
                .then(success => {
                    if (!success)
                        confirm('There was an error processing your request.');
                })
                .catch(error => {
                    confirm('There was an error processing your request.');
                });
        }
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/loan-officer-region-reference/subregions/subregions.component.ts